import React, { useRef, useEffect, useState } from "react";

const AboutUs = () => {
  return (
    <div className="p-4" id="aboutUs">
      <p className=" text-blue-950 md:text-[24px] text-center text-[20px] font-bold">
        About Us
      </p>

      <div className="flex flex-col lg:flex-row lg:justify-center lg:items-start lg:gap-8">
          <div className="flex justify-center lg:w-1/2">
            <img
              src="./assets/Images/about.gif"
              className="h-60 sm:h-72 lg:h-80 object-contain"
              alt="Helper"
            />
          </div>
        <div className="text-center w-[100%] lg:w-[50%] lg:mr-28">
          <p className="md:text-lg text-justify  text-sm lg:mt-14">
            Aditya and Associates is a trusted name in the building construction
            material supply industry. With years of experience, we pride
            ourselves on providing top-quality materials that meet the needs of
            diverse clients. From large-scale construction companies to
            individual builders, we cater to a wide range of projects with
            efficiency, reliability, and a commitment to excellence.
            <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
